import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {map, Observable, merge, catchError, throwError} from 'rxjs';
import {environment} from "../../environments/environment";
import { MaintenanceTpre } from "../models/MaintenanceTpre";


@Injectable({
    providedIn: 'root'
})


export class TpreService {

    private url = "";
    private apiEndpoint = environment.tpreApiEndpoint;

    constructor(private readonly httpClient:HttpClient) { }

    getTpreTable(): Observable<MaintenanceTpre[]> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.get<MaintenanceTpre[]>(this.url).pipe(
          map((res) => {
            return res.map((tpre) => {
              return MaintenanceTpre.transformTpre(tpre);
            })
          })
        );
    }

    addUpdateTpre(tpre: MaintenanceTpre, add: boolean): Observable<MaintenanceTpre> {
        console.log("processing...");
        console.log(tpre);
        if (add) {
          return this.addTpre(tpre);
        } else {
          return this.updateTpre(tpre);
        }
      }

      addTpre(tpre: MaintenanceTpre): Observable<MaintenanceTpre> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.post<MaintenanceTpre>(this.url, tpre).pipe(
          map((res: any) => {
            return MaintenanceTpre.transformTpre(res);
          }),
          catchError((err: any) => {
            console.log("Saving failed for tpre: " + tpre);
            return throwError(err);
          })
        );
      }

      updateTpre(tpre: MaintenanceTpre): Observable<MaintenanceTpre> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.put<MaintenanceTpre>(this.url, tpre).pipe(
          map((res: any) => {
            return MaintenanceTpre.transformTpre(res);
          }),
          catchError((err: any) => {
            console.log("Saving failed for tpre: " + tpre);
            console.log(tpre);
            return throwError(err);
          })
        );
      }
}
